const { h, render, Component } = require('preact');

class SingleActionSSAView extends Component {
  constructor(props) {
    super(props);
    this.getSSA = this.getSSA.bind(this);
  }

  getSSA() {
    let rel = "noopener noreferrer";
    let target = "_blank";
    if (this.props.SSAType === "refund_request") {
      rel = "";
      target = "";
    }
    return (
      <a href={this.props.SSADetails.UrlForSSA} class="btn-invert ssa-button" rel={rel} target={target} data-bhw={("web2018_ssa_" + this.props.SSADetails.SSAText).replace(' ', '_')}>
       {this.props.SSADetails.SSAText}
      </a>
    )
  }

  render() {
    return (
      <div class="ssa-holder">
        {this.getSSA()}
      </div>
    );
  }
}
module.exports = SingleActionSSAView
